import React, { Component } from 'react';
import { Button, Toolbar, Autocomplete, TextField } from 'react-md';
import '../Wizard.scss';
import { ProgressBar } from '../../index';

export default class LandmarkStep extends Component {
  state = {
    landmarkName: '',
    autoCompleteKey: ''
  };

  componentDidMount() {
    const { data } = this.props;
    if (data) {
      this.setState({
        landmarkName: data.childName
      });
    }
    if (!this.props.landmarks || this.props.landmarks.length < 1) {
      this.props.actions.getLandmarks();
    }
  }

  handleNameChange = (data) => {
    this.setState({ landmarkName: data, autoCompleteKey: '' });
    this.props.actions.update({ landmarkName: data, autoCompleteKey: '' });
  }

  handleAutocomplete = (data) => {
    const landmark = this.props.landmarks.filter(point => point.name === data);
    const dupeOrgRelations = data &&
      this.props.landmarks.filter(x => x.id === landmark[0] && landmark[0].id);
    if (landmark) {
      this.setState({ landmarkName: landmark[0].name, autoCompleteKey: landmark[0].id });
      this.props.actions.update({ landmarkName: landmark[0].name, landmarkKey: landmark[0].id, dupeOrgs: dupeOrgRelations });
    }
  }

  handleSubmit = async() => {
    this.props.actions.confirmOrg(false, this.props.editData, {});
    this.props.hide();

  }

  render() {
    const { landmarkName, autoCompleteKey } = this.state;
    const { data, title, previousStep } = this.props;
    const autocompleteData = (this.props.landmarks && this.props.landmarks.map(x => { return { name: x.name, id: x.id, key: x.id };})) || [];
    return (
      <div className="wrapper">
        <Toolbar
          fixed
          colored
          titleStyle={{ margin: '0 auto', paddingRight: ' 36px' }}
          title={data ? `Edit ${title.toLowerCase()}` : `Creating a new ${title.toLowerCase()}`}
          nav={<Button id="dialog-back-button" onClick={previousStep} icon >arrow_back</Button>}
          style={{ backgroundColor: '#6200EE' }}
        />
        <ProgressBar step={this.props.currentStep} />
        <div className="wizard-step">
          <div className="wizard-step-header-container">
            <div className="wizard-step-header">To which landmark is this venue team assigned?</div>
          </div>
          <div>
            {data ?
              <TextField
                id="organization-name-input"
                className="wizard-text-input"
                label="Name"
                value={landmarkName}
                onChange={(v) => this.handleNameChange(v)}
              />
              :
              <Autocomplete
                id="organization-name-input"
                className="wizard-text-input"
                label="Name"
                data={autocompleteData}
                dataLabel="name"
                filter={Autocomplete.caseInsensitiveFilter}
                value={landmarkName}
                onChange={(v) => this.handleNameChange(v)}
                onAutocomplete={this.handleAutocomplete}
                autocompleteWithLabel
              />}
          </div>
          <div>
            <Button className="wizard-button" disabled={!autoCompleteKey} flat onClick={this.handleSubmit} children="CONFIRM EDITS" />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Wizard/LandmarkStep/LandmarkStep.jsx